import Client from 'requests/client';

const client = new Client({ basePath: '/users/two_factor_authentication' });

export const createTwoFactorAuthenticationRequest = (otp_attempt) => {
  return client.create({
    data: { two_factor_authentication: { otp_attempt } },
  });
};
